import React from 'react';
import { getMetricsByCategory } from './registry/MetricRegistry';
import MetricCard from './cards/MetricCard';

const CATEGORY_LABELS = {
  'users': 'Users & Growth',
  'assessment': 'Assessment & Engagement',
  'employer-funnel': 'Employer Funnel',
  'candidate-funnel': 'Candidate Funnel',
  'marketplace': 'Marketplace Health',
  'revenue': 'Revenue & Credits',
  'cohorts': 'Cohorts & Retention',
  'operational': 'Operational',
};

const CategoryView = ({ category, pinnedCards, onTogglePin }) => {
  const metrics = getMetricsByCategory(category);

  return (
    <div>
      <h3 className="text-xl font-semibold text-lightgray mb-4">
        {CATEGORY_LABELS[category] || category}
      </h3>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {metrics.map(({ metricId }) => (
          <MetricCard
            key={metricId}
            metricId={metricId}
            isPinned={pinnedCards.includes(metricId)}
            onTogglePin={onTogglePin}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryView;
